import { gsap } from 'gsap'

const DURATION_OPEN = 0.5
const DURATION_CLOSE = 0.35

/**
 * Acordeão dos fundos.
 *
 * O <details> nativo não anima a altura: o painel simplesmente aparece/some.
 * Aqui interceptamos o clique e animamos com GSAP, mantendo a semântica do
 * <details> (e o funcionamento sem JS, caso o script falhe).
 */
export default function () {
	const items = document.querySelectorAll('[js-fundo]')
	if (!items.length) return

	const close = (details, animate = true) => {
		const panel = details.querySelector('[js-fundo-panel]')
		if (!panel || !details.open) return

		if (!animate) {
			details.open = false
			return
		}

		details.dataset.animating = 'true'
		gsap.to(panel, {
			height: 0,
			opacity: 0,
			duration: DURATION_CLOSE,
			ease: 'power2.inOut',
			onComplete: () => {
				details.open = false
				gsap.set(panel, { height: 'auto', opacity: 1 })
				details.dataset.animating = 'false'
			},
		})
	}

	const open = (details) => {
		const panel = details.querySelector('[js-fundo-panel]')
		const inner = panel?.firstElementChild
		if (!panel) return

		details.dataset.animating = 'true'
		details.open = true

		gsap.fromTo(
			panel,
			{ height: 0, opacity: 0 },
			{
				height: 'auto',
				opacity: 1,
				duration: DURATION_OPEN,
				ease: 'power3.out',
				onComplete: () => {
					gsap.set(panel, { height: 'auto' })
					details.dataset.animating = 'false'
				},
			}
		)

		// conteúdo entra logo atrás da abertura, dando profundidade ao movimento
		if (inner) {
			gsap.fromTo(inner, { y: -12, opacity: 0 }, { y: 0, opacity: 1, duration: 0.45, delay: 0.12, ease: 'power2.out' })
		}
	}

	items.forEach((details) => {
		const summary = details.querySelector('summary')
		if (!summary) return

		summary.addEventListener('click', (event) => {
			event.preventDefault()
			if (details.dataset.animating === 'true') return

			if (details.open) {
				close(details)
				return
			}

			// acordeão: abrir um fecha os demais
			items.forEach((other) => {
				if (other !== details) close(other)
			})

			open(details)
		})
	})
}
